var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUrine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.25586 3.51318V23.9433C4.25586 24.527 4.729 25.0001 5.3127 25.0001H19.6875C20.2711 25.0001 20.7443 24.527 20.7443 23.9433V3.51318H4.25586Z",
    fill: "#E1EFFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2803 3.51318V25.0001H19.6873C20.2709 25.0001 20.7441 24.527 20.7441 23.9433V3.51318H18.2803Z",
    fill: "#CADDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4155 5.72441H3.58394C3.14253 5.72441 2.78467 5.36655 2.78467 4.92515V0.799268C2.78462 0.357861 3.14248 0 3.58394 0H21.4155C21.8569 0 22.2148 0.357861 22.2148 0.799268V4.92515C22.2148 5.36655 21.8569 5.72441 21.4155 5.72441Z",
    fill: "#A67C52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4158 0H19.7261V5.72441H21.4158C21.8572 5.72441 22.215 5.36655 22.215 4.92515V0.799268C22.2151 0.357861 21.8572 0 21.4158 0Z",
    fill: "#936947"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.02553 4.19683C5.81724 4.19683 5.64844 4.02798 5.64844 3.81973V1.90493C5.64844 1.69668 5.81724 1.52783 6.02553 1.52783C6.23383 1.52783 6.40263 1.69668 6.40263 1.90493V3.81973C6.40258 4.02798 6.23383 4.19683 6.02553 4.19683Z",
    fill: "#C49E7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.26333 4.19683C9.05503 4.19683 8.88623 4.02798 8.88623 3.81973V1.90493C8.88623 1.69668 9.05503 1.52783 9.26333 1.52783C9.47163 1.52783 9.64043 1.69668 9.64043 1.90493V3.81973C9.64048 4.02798 9.47168 4.19683 9.26333 4.19683Z",
    fill: "#C49E7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5001 4.19683C12.2918 4.19683 12.123 4.02798 12.123 3.81973V1.90493C12.123 1.69668 12.2918 1.52783 12.5001 1.52783C12.7084 1.52783 12.8772 1.69668 12.8772 1.90493V3.81973C12.8773 4.02798 12.7085 4.19683 12.5001 4.19683Z",
    fill: "#C49E7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7375 4.19683C15.5291 4.19683 15.3604 4.02798 15.3604 3.81973V1.90493C15.3604 1.69668 15.5291 1.52783 15.7375 1.52783C15.9458 1.52783 16.1145 1.69668 16.1145 1.90493V3.81973C16.1145 4.02798 15.9458 4.19683 15.7375 4.19683Z",
    fill: "#C49E7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9752 4.19683C18.7669 4.19683 18.5981 4.02798 18.5981 3.81973V1.90493C18.5981 1.69668 18.7669 1.52783 18.9752 1.52783C19.1835 1.52783 19.3523 1.69668 19.3523 1.90493V3.81973C19.3523 4.02798 19.1835 4.19683 18.9752 4.19683Z",
    fill: "#C49E7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25586 8.56494V23.943C4.25586 24.5267 4.729 24.9998 5.3127 24.9998H19.6875C20.2711 24.9998 20.7443 24.5267 20.7443 23.943V8.56494H4.25586Z",
    fill: "#FFDF24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2803 24.9998H19.6873C20.2709 24.9998 20.7441 24.5267 20.7441 23.943V8.56494H18.2803V24.9998Z",
    fill: "#FFC627"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.85732 12.0369C8.06563 12.0369 8.23442 11.8681 8.23442 11.6598C8.23442 11.4516 8.06563 11.2827 7.85732 11.2827H4.25586V12.037L7.85732 12.0369Z",
    fill: "#FFC627"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.80142 15.3685C7.00972 15.3685 7.17852 15.1996 7.17852 14.9914C7.17852 14.7831 7.00972 14.6143 6.80142 14.6143H4.25586V15.3685H6.80142V15.3685Z",
    fill: "#FFC627"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.85732 18.7005C8.06563 18.7005 8.23442 18.5316 8.23442 18.3234C8.23442 18.1151 8.06563 17.9463 7.85732 17.9463H4.25586V18.7005H7.85737V18.7005H7.85732Z",
    fill: "#FFC627"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.80142 22.0325C7.00972 22.0325 7.17852 21.8637 7.17852 21.6554C7.17852 21.4472 7.00972 21.2783 6.80142 21.2783H4.25586V22.0326H6.80142V22.0325Z",
    fill: "#FFC627"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrine);
export default __webpack_public_path__ + "static/media/urine.8db143b6.svg";
export { ForwardRef as ReactComponent };